const courseConfig = {
  "X033517": {
    "subjectAiUrl": "https://example.com/subject",
    "courseAiUrl": "https://example.com/course",
  },
  "G140501": {
    "subjectAiUrl": "https://www.baidu.com/",
  },
  "Z140504": {
    "courseAiUrl": "https://cn.bing.com/",
  },
};

export default courseConfig;
